import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { GamificationProvider } from './contexts/GamificationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { ReservaSalas } from './pages/ReservaSalas';
import { Cardapio } from './pages/Cardapio';
import { Diretorio } from './pages/Diretorio';
import { Equipamentos } from './pages/Equipamentos';
import { Mural } from './pages/Mural';
import { PublicPost } from './pages/PublicPost';
import { AdminPanel } from './pages/AdminPanel';
import { TrocaProteinas } from './pages/TrocaProteinas';
import { Aniversariantes } from './pages/Aniversariantes';
import { RH } from './pages/RH';
import SorteioBrindes from './pages/SorteioBrindes';
import RelatorioInscricoesBrindes from './pages/RelatorioInscricoesBrindes';
import Profile from './pages/Profile';
import { DebugInfo } from './components/DebugInfo';
import GoogleOAuth from './pages/GoogleOAuth';
import { GoogleCalendarAdmin } from './pages/GoogleCalendarAdmin';
import { PublicChecklist } from './pages/PublicChecklist';
import { FrotaPortal } from './pages/FrotaPortal';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <GamificationProvider>
          <Router>
            <div className="min-h-screen bg-gray-50">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/callback" element={<GoogleOAuth />} />
                <Route path="/public/post" element={<PublicPost />} />

                {/* ROTA PÚBLICA DO CHECKLIST */}
                <Route path="/checklist/:token" element={<PublicChecklist />} />

                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/perfil"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/reservas"
                  element={
                    <ProtectedRoute>
                      <ReservaSalas />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/cardapio"
                  element={
                    <ProtectedRoute>
                      <Cardapio />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/troca-proteina"
                  element={
                    <ProtectedRoute>
                      <TrocaProteinas />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/diretorio"
                  element={
                    <ProtectedRoute>
                      <Diretorio />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/equipamentos"
                  element={
                    <ProtectedRoute>
                      <Equipamentos />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/mural"
                  element={
                    <ProtectedRoute>
                      <Mural />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/aniversariantes"
                  element={
                    <ProtectedRoute>
                      <Aniversariantes />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/rh"
                  element={
                    <ProtectedRoute>
                      <RH />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/sorteio"
                  element={
                    <ProtectedRoute>
                      <SorteioBrindes />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/relatorio-brindes"
                  element={
                    <ProtectedRoute requireAdmin>
                      <RelatorioInscricoesBrindes />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/frota"
                  element={
                    <ProtectedRoute>
                      <FrotaPortal />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/google-calendar"
                  element={
                    <ProtectedRoute requireAdmin>
                      <GoogleCalendarAdmin />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/admin/*"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/painel"
                  element={
                    <ProtectedRoute>
                      <Navigate to="/admin" replace />
                    </ProtectedRoute>
                  }
                />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>

              <Toaster position="top-right" />
              <DebugInfo />
            </div>
          </Router>
        </GamificationProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;